import forestFirst from './forest-first.svg';
import lineHeader from './line-header.svg';
import smartPro from './smart-pro.svg';
import warningGray from './warning-gray.svg';
import sustainabilityPlanetIcon from './sustainability-planet-icon.svg';
import printerDropIcon from './printer-drop-icon.svg';
import truckIcon from './truck-icon.svg';
import getTheHpAppIcon from './get-the-hp-app-icon.svg';

const Images = {
  forestFirst,
  lineHeader,
  smartPro,
  warningGray,
  sustainabilityPlanetIcon,
  printerDropIcon,
  truckIcon,
  getTheHpAppIcon,
};

export default Images;
